// extracted by mini-css-extract-plugin
export var activity = "form-module--activity--31416";
export var age = "form-module--age--a4027";
export var checkboxContainer = "form-module--checkbox-container--8f942";
export var collaboration = "form-module--collaboration--c328f";
export var fourColumns = "form-module--four-columns--5eb34";
export var generalInfo = "form-module--general-info--e4602";
export var height = "form-module--height--14746";
export var row = "form-module--row--7b501";
export var separator = "form-module--separator--58ac9";
export var sleep = "form-module--sleep--3842a";
export var subtitle = "form-module--subtitle--f6d02";
export var thigh = "form-module--thigh--c0852";
export var title = "form-module--title--39212";
export var waist = "form-module--waist--b89ad";
export var weight = "form-module--weight--790af";